import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer'; // Import the new Footer component
import HeroSection from './components/HeroSection';
import ValuePropositionCards from './components/ValuePropositionCards';
import InteractiveTimeline from './components/InteractiveTimeline';
import FeaturedProjects from './components/FeaturedProjects';
import TestimonialCarousel from './components/TestimonialCarousel';
import BlogPreview from './components/BlogPreview';
import SocialProofSection from './components/SocialProofSection';
import CTASection from './components/CTASection';

const Homepage = () => {
  useEffect(() => {
    // Scroll to top on component mount
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Ebesoh Adrian - Full-Stack Developer & Community Builder | React Expert & Mentor</title>
        <meta
          name="description"
          content="Ebesoh Adrian is a full-stack developer specializing in React/React Native, community builder behind CodersHub (15K+ members), and mentor who has guided 200+ developers. Building scalable solutions and scalable careers."
        />
        <meta name="keywords" content="React Developer, Full-Stack Developer, Community Builder, Mentorship, CodersHub, JavaScript, React Native, Web Development, Mobile Development" />
        <meta name="author" content="Adrian" />

        {/* Open Graph */}
        <meta property="og:title" content="Adrian - Full-Stack Developer & Community Builder" />
        <meta property="og:description" content="Building scalable solutions and scalable careers. React expert, CodersHub founder, and mentor to 200+ developers worldwide." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ebesohadrian.netlify.app" />
        <meta property="og:image" content="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=1200&h=630&fit=crop&crop=face" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Adrian - Full-Stack Developer & Community Builder" />
        <meta name="twitter:description" content="Building scalable solutions and scalable careers. React expert, CodersHub founder, and mentor to 200+ developers worldwide." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=1200&h=630&fit=crop&crop=face" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Person",
            "name": "Adrian",
            "jobTitle": "Full-Stack Developer & Community Builder",
            "description": "React/React Native expert, CodersHub founder, and mentor specializing in scalable web and mobile applications",
            "url": "https://ebesohadrian.netlify.app",
            "sameAs": [
              "https://github.com/adrian",
              "https://linkedin.com/in/adrian",
              "https://twitter.com/adrian"
            ],
            "knowsAbout": [
              "React",
              "React Native",
              "JavaScript",
              "TypeScript",
              "Node.js",
              "Community Building",
              "Mentorship",
              "Web Development",
              "Mobile Development"
            ]
          })}
        </script>
      </Helmet>
      <div className="min-h-screen bg-background">
        {/* Header */}
        <Header />

        {/* Main Content */}
        <main>
          {/* Hero Section */}
          <HeroSection />

          {/* Value Proposition Cards */}
          <ValuePropositionCards />

          {/* Interactive Timeline */}
          <InteractiveTimeline />

          {/* Featured Projects */}
          <FeaturedProjects />

          {/* Testimonial Carousel */}
          <TestimonialCarousel />

          {/* Blog Preview */}
          <BlogPreview />

          {/* Social Proof Section */}
          <SocialProofSection />

          {/* CTA Section */}
          <CTASection />
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
};

export default Homepage;